.user-area {
  display: flex;
  flex-direction: column;
}

.tab {
  cursor: pointer;
}

.game-tile {
  height: 200px;
  width: 100px;
  min-width: 100px;
  display: flex;
  justify-content: center;
  align-items: center;
}

.carousel-panels {
  min-height: 156px; /* to prevent jumping on array update */
}

.hidden {
  display: none;
}
.user-area {
  gap: var(--ui-space-md);
  background: var(--ui-user-area-bg, var(--ui-color-gray-1));
  border-radius: var(--ui-border-radius-lg);
  margin-bottom: 28px;
  padding: var(--ui-space-md) 0;
}

.user-area--is-nested {
  background-color: transparent;
  margin-bottom: 0;
  border-radius: 0;
}

.tab.selected {
  text-decoration: underline var(--ui-color-secondary);
  -webkit-text-decoration-line: underline;
  -webkit-text-decoration-color: var(--ui-color-secondary);
  text-underline-offset: 6px;
  text-decoration-thickness: 0.1em;
}

.game-tile {
  background: var(--ui-color-secondary);
  border-radius: 15px;
  color: black;
  margin-right: 10px;
}

.user-area ui-games-carousel {
  --padding-offset: var(--ui-space-md);
}
